export default "__VITE_ASSET__tN7j7YDX__"